const ROUTER_MAP = {
  平台门户: 'platformPortal',
  交易市场: 'tradingMarket',
  产业数据库: 'industryData',
  竞争对手情报库: 'competitorData',
  服务与支持: 'ipFinancialProducts',
  IP金融产品: 'ipFinancialProducts',
  第三方服务: 'serviceAndSupport',
  综合信息: 'generalInfo',
  新闻资讯: 'generalInfo?informationType=',
  行业资讯: 'generalInfo?informationType=1',
  政策制度: 'generalInfo?informationType=2',
  产业分析: 'generalInfo?informationType=3',
  专利专题库: 'patentTopic',
  人才团队: 'talentData',
  服务机构: 'serviceAndSupport',
  成果展示: 'achievementDisplay',
  技术需求库: 'technicalRLibrary',
  智能撮合: 'intelligenceMatch',
  产业信息服务: 'IndustryInformation',
  开放许可: 'openLicense',
  专利检索: 'patyee'
}

module.exports = {
  ROUTER_MAP
}
